'use strict';

var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require('../internals/typed-arrays-constructors-requires-wrappers');

var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var typedArrayFrom = require('../internals/typed-array-from'); // `%TypedArray%.from` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.from


ArrayBufferViewCore.exportStatic('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);